/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetExcelConfigTeamDto
 */
export interface GetExcelConfigTeamDto {
    /**
     * 
     * @type {string}
     * @memberof GetExcelConfigTeamDto
     */
    id: string;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetExcelConfigTeamDto
     */
    team: GetTeamDto;
}

/**
 * Check if a given object implements the GetExcelConfigTeamDto interface.
 */
export function instanceOfGetExcelConfigTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "team" in value;

    return isInstance;
}

export function GetExcelConfigTeamDtoFromJSON(json: any): GetExcelConfigTeamDto {
    return GetExcelConfigTeamDtoFromJSONTyped(json, false);
}

export function GetExcelConfigTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExcelConfigTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'team': GetTeamDtoFromJSON(json['team']),
    };
}

export function GetExcelConfigTeamDtoToJSON(value?: GetExcelConfigTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'team': GetTeamDtoToJSON(value.team),
    };
}

